import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Document = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Document' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M14,1 L14,8 L21,8 M21,23 L3,23 L3,1 L15,1 L18,4 L21,7 L21,23 L21,23 L21,23 Z' />
  </StyledIcon>
);
